/* eslint-disable @typescript-eslint/no-explicit-any */

import { APP_CONSTANTS } from "components/constants/AppConstants";
import { parseJwt } from "utils";

export const persistToken = (token: string, refresh_token: string): void => {
  localStorage.setItem("accessToken", token);
  localStorage.setItem("is_first_time_login", "1");
  localStorage.setItem("refresh_token", refresh_token);
  localStorage.setItem("account_info", JSON.stringify(parseJwt(token)));
};

export const readToken = (): string => {
  return localStorage.getItem("accessToken") || "";
};

export const persistUser = (user: any): void => {
  if (user) localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("app_version", APP_CONSTANTS.APP_VERSION); // Store new version
  //localStorage.setItem("user", user);
};

export const readUser = (): any | null => {
  const userStr = localStorage.getItem("user");

  return userStr ? JSON.parse(userStr) : null;
};

export const deleteToken = (): void => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("account_info");
  localStorage.removeItem("is_first_time_login");
};

export const getAccountInfo = (): { ClientID: string; AccountID: string } | null => {
  const accountInfo = localStorage.getItem("account_info");

  return accountInfo ? (JSON.parse(accountInfo) as { ClientID: string; AccountID: string }) : null;
};

export const getClient = (): string | null => {
  const accountInfo = localStorage.getItem("account_info");
  if (accountInfo) {
    const parsedAccountDetails = JSON.parse(accountInfo);
    return parsedAccountDetails.ClientID ? parsedAccountDetails.ClientID : null;
  }
  return null;
};

export const checkFeatureAllowed = (feature: string): boolean => {
  const userInfo = readUser();
  const companyList: any = APP_CONSTANTS.FEATURE_HIDE_COMPANY;
  if (userInfo && userInfo.company && companyList.indexOf(userInfo.company.id) > -1) return false;
  return true;
};

export const isSalesRep = (): boolean => {
  const userInfo = readUser();
  if (userInfo && userInfo.role && userInfo.role === APP_CONSTANTS.ROLES.SALES_REP) return true;
  return false;
};

export const isAccount = (): boolean => {
  const accountInfo = localStorage.getItem("account_info");
  const parsedAccountInfo = accountInfo ? (JSON.parse(accountInfo) as any) : null;

  return parsedAccountInfo ? (parsedAccountInfo.AccountID ? true : false) : false;
};

export const isSmartReqAllowed = (): boolean => {
  if (getPluginDetails("Smart Recruiters")) return true;
  return false;
};

export function getPluginDetails(name: string) {
  const userInfo = readUser();
  if (userInfo.plugins) {
    for (const plugin of userInfo.plugins) {
      if (plugin.name === name) {
        return plugin;
      }
    }
  }
  return null;
}

export const isFeatureAllowed = (feature: string): boolean => {
  const userInfo = readUser();

  if (
    userInfo &&
    userInfo.feature_list &&
    userInfo.feature_list.length > 0 &&
    userInfo.feature_list.findIndex((f: any) => f.feature_code === feature) > -1
  ) {
    return true;
  }
  return false;
};

export const getSubscriptionId = (): string | null => {
  const userInfo = readUser();
  if (userInfo && userInfo.product && userInfo.product.product_id) {
    return userInfo.product.product_id ? userInfo.product.product_id : "1";
  }
  return null;
};
export const getSubscriptionDetails = (): any => {
  const userInfo = readUser();
  if (userInfo && userInfo.product) {
    return userInfo.product;
  }
  return null;
};

export const setSubscription = (product: any, featureList: any) => {
  const userInfo = readUser();
  userInfo.product = product;
  userInfo.feature_list = featureList;
  persistUser(userInfo);
};

export const setRedirectRule = (status: boolean) => {
  const userInfo = readUser();
  userInfo.redirect_to_settings = status;
  persistUser(userInfo);
};

export const isFirstTime = () => {
  return localStorage.getItem("is_first_time_login");
};

export const deleteUser = (): void => localStorage.removeItem("user");
export const removeUserLoggedInCount = (): void => localStorage.removeItem("userLoggedInCount");
